/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { IPageCampaignsTranslation } from '../../../../modules/internationalization/types/pages/campaigns';
import {
    TableCell,
    TableCellLink,
    TableFilterMultiSelect,
    TableHeader,
    TTableColumnConfig,
    useTableCellCampaignInfo,
} from '../../../../modules/table';
import TableSubscriberFilter from '../../../PageSubscriberMobile/components/TableSubscriberFilter';
import { ICampaignsTable } from '../../types';

export const CampaignsTableColumns = (
    { table }: IPageCampaignsTranslation,
): TTableColumnConfig<ICampaignsTable> => {

    const useCampaignIdCell = ({ name, id }: ICampaignsTable) => useTableCellCampaignInfo(id, name);

    return {
        /* Наименование */
        name: {
            accessor: 'name',
            Header: <TableHeader label={table.name?.header ?? ''} name="name">
                <TableSubscriberFilter>
                    <TableFilterMultiSelect name="name"/>
                </TableSubscriberFilter>
            </TableHeader>,
            ...TableCellLink<ICampaignsTable>(useCampaignIdCell),
        },
        /* Описание */
        description: {
            accessor: 'description',
            Cell: props => TableCell(props)({
                render: ({ row }) => {
                    return <div dangerouslySetInnerHTML={{ __html: row.description }}/>;
                },
            }),
        },
    };
};
